import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import xd from '../assets/images/xd.jpg';
import photoshop from '../assets/images/photoshop.png';
import ps from '../assets/images/ps.png';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class PhotoShop extends Component {
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${ps})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"For you to sleep well at night, the aesthetic, the quality, has to be carried all the way through."</p>
                <p>
                &mdash; Steve Jobs.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${xd})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Graphic Design</h3>
            <img src={photoshop} alt="Full-stack JavaScript training in abuja" />
            <p> 
             Learn Graphic design techniques using Adobe Photoshop. Learn how to come up with creative graphics, text and color effects.
            </p>
            <p> 
            Become a Graphic design expert.
            </p>

            <h3>courses</h3>
            <p>
                Adobe Photoshop.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default PhotoShop;